// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#context-menu{\n\tposition: absolute;\n\tz-index: 19999;\n}\n#context-menu .dropdown-menu{\n\tdisplay: block;\n}", ""]);
// Exports
module.exports = exports;
